//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "MenuGroupComponent",
  model: {
    prop: "show",
    event: "updateIndex",
  },
  props: {
    options: {
      type: Array,
      default: () => {
        return [
          {
            text: "a",
          },
          {
            text: "a",
          },
        ];
      },
    },
    index: {
      // 选中索引
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      selectIndex: this.index, // 选中索引
    };
  },
  watch: {
    selectIndex(val) {
      this.$emit("updateIndex", val);
    },
    index(val) {
      this.selectIndex = val;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/login/send_code/Radio.vue